module.exports = __webpack_public_path__ + "img/22.c1178ce9.png";